import { Logout as LogoutIcon } from "@mui/icons-material";
import { Popover } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import Avatar from "../../../../assets/images/avatar-df.png";
import useNoti from "../../../../hooks/useNoti";
import { useTranslation } from "../../../../i18n/useTranslation";
import { AppNotifications } from "../../../../models";
import { AuthService } from "../../../../services";
import { RequestUtil, loadState, removeState, renderErrorImage } from "../../../../utils";
import { DEFAULT_IMG_ALT } from "../../../constants";
import { APP_ROUTES } from "../../../constants/module";
import "./index.scss";

type P_Props = {
  onClose: () => void;
  anchorEl: HTMLElement | null;
  avatarImg: string;
  profile?: {
    code?: string;
    name?: string;
    email?: string | null;
    avatar?: string | null;
  } | null;
};
const SignOut: React.FC<P_Props> = (props) => {
  const { t } = useTranslation();
  const [pushNoti] = useNoti();
  const token = loadState();
  const displayName = props.profile?.name || props.profile?.code || "Admin";
  const displayEmail = props.profile?.email || props.profile?.code || "";

  const onLogout = async () => {
    try {
      if (token) {
        await AuthService.onLogout();
      }
    } catch {
      /* ignore revoke errors — still clear local session */
    }
    RequestUtil.removeAuthHeader();
    removeState();
    pushNoti(AppNotifications.SUCCESS, t("auth.signOutSuccess"));
    setTimeout(() => {
      window.location.href = `${APP_ROUTES.SIGN_IN}`;
    }, 500);
  };

  return (
    <Popover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <div className="app-toolbar-right-profile">
        <div className="name">
          <img
            src={props.profile?.avatar || Avatar}
            alt={DEFAULT_IMG_ALT}
            onError={renderErrorImage()}
          />
          <div>
            {displayName}
            <div className="email">{displayEmail}</div>
          </div>
        </div>
        <div className="menu-list">
          <Link to={APP_ROUTES.PROFILE} onClick={props.onClose}>
            {t("profile.title")}
          </Link>
          <button onClick={onLogout}>
            <LogoutIcon />
            &ensp;{t("auth.signOut")}
          </button>
        </div>
      </div>
    </Popover>
  );
};

export default SignOut;
